import $router from 'wee-routes';
import './bootstrap';
import banner from '../components/banner/index';
import blogIndex from '../components/l-blog-index/index';
import blogPost from '../components/blog-post/index';
import footerNav from '../components/footer-navigation/index';
import footerSocial from '../components/footer-social/index';
import navigation from '../components/navigation/index';
import newsletter from '../components/footer-newsletter/index';
import richText from '../components/rich-text/index';
import search from '../components/search/index';
import topBar from '../components/top-bar/index';
import header from '../components/l-header/index';

const commonScripts = [
    topBar,
    navigation,
    newsletter,
    footerSocial,
    footerNav,
    banner,
    search,
    header,
];

$router.map([
    {
        path: '/',
        handler: [...commonScripts],
    },
    {
        path: '/blog/',
        handler: [...commonScripts],
    },
    {
        path: '/blog/(athome|atschool)',
        handler: [blogIndex, ...commonScripts],
    },
    {
        path: '/(athome|atschool)',
        handler: [blogIndex, ...commonScripts],
    },
    {
        path: '/blog/(athome|atschool)/page/:page(\\d+)',
        handler: [blogIndex, ...commonScripts],
    },
    {
        path: '/(athome|atschool)/page/:page(\\d+)',
        handler: [blogIndex, ...commonScripts],
    },
    {
        path: '/blog/:slug', // TODO
        handler: [...commonScripts, blogPost, richText],
    },
    {
        path: '/:slug', // TODO
        handler: [...commonScripts, blogPost, richText],
    },
]).notFound({
    init() {
        console.error(404); // eslint-disable-line
    },
}).run();
